module.exports = __webpack_public_path__ + "media/touchdown_right.13ab095e.mp4";